module.exports = __webpack_public_path__ + "img/25_75.3749e3c6.png";